import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/clients").then((r) => setClients(r.data));
  }, []);

  const filtered = clients.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-3xl font-bold text-[#181854] tracking-tight">Clients & Assets</h1>
        <p className="text-[#6A6E85] mt-1">{clients.length} clients on file</p>
      </div>
      <input
        placeholder="Search clients…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        data-testid="clients-search"
        className="w-full max-w-md px-4 py-2.5 rounded-lg border border-[#E4E6EF] focus:border-[#4F9CE0] focus:ring-2 focus:ring-[#4F9CE0]/20 outline-none bg-white"
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map((c) => (
          <Link
            key={c.id}
            to={`/office/clients/${c.id}`}
            data-testid={`client-card-${c.id}`}
            className="bg-white rounded-xl border border-[#E4E6EF] p-5 shadow-sm hover:-translate-y-0.5 transition-transform duration-200"
          >
            <div className="text-lg font-semibold text-[#181854]">{c.name}</div>
            <div className="text-sm text-[#6A6E85] mt-1">
              {c.phones?.[0] || "No phone"}
            </div>
            <div className="text-xs text-[#6A6E85] mt-1">{c.billing_ref}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
